import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      internationalSearch: {
        BUSINESS_CONCIERGE_SERVICE: 'Business Concierge Service',
        REGISTRATION_NUMBER: 'Registration Number: ',
        RELY_INTERNATIONAL_SEARCH: 'You Can Rely on International Search',
        OUR: 'Our',
        PROVIDES_A_SEAMLESS:
          'provides a seamless search and discovery experience, by passing untrusted third-party static databases to support direct connections to government registries.',
        WE_PROVIDES: 'We provide unparalleled access to:',
        AUDIT_PROOF:
          'Audited and timestamped data from over 115 million companies.',
        DATA_FROM: 'Data from over 100 countries and jurisdictions',
        BUSINESS_DATA:
          'Business data that complies with the latest AML data requirements',
        ORIGINAL_COMPANY:
          'Original company filings and documents that include register reports & certificates, annual accounts, articles of association, and historical filings.',
        WE_ARE_ALWAYS:
          '  We are always expanding our live network to connect you with new official sources across multiple jurisdictions around the world',
        NEED_TO_DIG:
          'Need To Dig Deeper? Make A Business Concierge Service Request',
        OUR_BUSINESS:
          ' For those who are unable to locate information on a particular firm, our team of experts at the Business Concierge Service can assist in obtaining official company documents from anywhere in the world. Upon contacting us, we will conduct research on the availability of the requested document. This service entails a handling fee per researched company, a fee for document services, and an official government fee that may differ based on the nation and type of document.',
        CREATE_REQUEST: 'Create Request',
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      internationalSearch: {
        BUSINESS_CONCIERGE_SERVICE: 'Dịch Vụ Business Concierge',
        REGISTRATION_NUMBER: 'Số Đăng Ký Doanh Nghiệp: ',
        RELY_INTERNATIONAL_SEARCH:
          'Thông tin về chức năng International Search',
        OUR: 'Chức năng',
        PROVIDES_A_SEAMLESS:
          ' cung cấp trải nghiệm tìm kiếm liền mạch, kết nối trực tiếp với cơ sở dữ liệu từ cổng thông tin đăng kí Chính phủ và loại bỏ các dữ liệu không đáng tin cậy từ Bên Thứ Ba.',
        WE_PROVIDES: 'Chúng tôi cung cấp quyền truy cập không giới hạn vào:',
        AUDIT_PROOF:
          'Dữ liệu được kiểm toán với từng mốc thời gian từ hơn 115 triệu doanh nghiệp.',
        DATA_FROM: 'Dữ liệu từ hơn 100 quốc gia và vùng lãnh thổ.',
        BUSINESS_DATA:
          'Dữ liệu kinh doanh tuân thủ các yêu cầu dữ liệu AML mới nhất.',
        ORIGINAL_COMPANY:
          'Hồ sơ và tài liệu gốc của doanh nghiệp bao gồm các tài liệu đăng ký và giấy chứng nhận, báo cáo kế toán năm, điều lệ doanh nghiệp và các dữ liệu kê khai lịch sử.',
        WE_ARE_ALWAYS:
          'Chúng tôi luôn nỗ lực mở rộng mạng lưới để kết nối bạn đến những nguồn dữ liệu mới ở khắp nơi trên thế giới. ',
        NEED_TO_DIG:
          'Cần tìm hiểu sâu hơn? Gửi yêu cầu sử dụng dịch vụ Business Concierge',
        OUR_BUSINESS:
          'Nếu bạn gặp khó khăn khi tìm kiếm thông tin doanh nghiệp, dịch vụ Business Concierge sẽ giúp bạn có được tài liệu chính thức từ các doanh nghiệp trên toàn cầu. Chúng tôi sẽ xem xét tính khả dụng của dữ liệu ngay khi được yêu cầu . Dịch vụ này bao gồm phí tìm kiếm cho mỗi công ty, phí dịch vụ tài liệu và phí từ phía chính phủ. Các loại phí có thể thay đổi tùy theo quốc gia và loại tài liệu.',
        CREATE_REQUEST: 'Tạo Yêu Cầu',
      },
    },
  }),
)
